<template>
    <div v-show="isVisible" class="media-container">
        <!--<router-link :to="createLink(src.link)">-->
        <div class="slide-container" ref="container" @click="click">
            <img v-if="isImage" class="slide" ref="image" src=""/>
            <video v-if="isVideo" autoplay muted playsinline class="slide" ref="video">
            </video>
        </div>
        <!--</router-link>-->
    </div>
</template>

<script>

    import detect from 'detect-browser';
    import {TweenMax, Linear} from 'gsap';

    export default {
        name: "Slide",
        props: ['src'],
        data() {
            return {
                mediaLoaded: false,
                isVisible: false,
                image: new Image(),
                inv: null,
                progress: 0,
                videoError: false,
                oldSlide: null,
                isIE: detect.detect().name === 'ie'
            }
        },
        computed: {
            isImage: function () {
                return this.src.type === 'image';
            },
            isVideo: function () {
                return this.src.type === 'video';
            }
        },
        methods: {
            click() {
                if (this.src.link !== '') {

                    this.$router.push({path: `/project/${this.src.link}`});
                }

            },
            showImage() {
                this.isVisible = true;
                this.$refs.container.style.opacity = 1;
                this.$refs.image.src = this.image.src;

                if (this.oldSlide) {
                    this.oldSlide.hide();
                }
                // this.slideIn();

                const duration = 4;
                this.progress = 0;

                this.$emit('loaded');

                TweenMax.to(this, duration, {
                    progress: 100,
                    ease: Linear.easeNone,
                    onUpdate: () => {
                        this.$emit('progress', this.progress);
                    },
                    onComplete: () => {
                        this.$emit('next');
                    }
                });

            },
            showVideo() {
                this.$refs.container.style.opacity = 1;

                if (this.oldSlide) {
                    this.oldSlide.hide();
                }

                this.isVisible = true;

                this.$emit('loaded');

                clearInterval(this.inv);
                this.inv = setInterval(() => {
                    const p = this.$refs.video.currentTime * 100 / this.$refs.video.duration;
                    this.$emit('progress', p);
                }, 30);
            },
            show(oldSlide) {
                this.oldSlide = oldSlide;
                const url = `/static/img/projects/${this.src.name}`;

                TweenMax.killTweensOf(this);

                clearInterval(this.inv);

                if (this.isImage) {

                    this.image.onload = () => {
                        this.showImage();
                        this.$bus.$emit('loaded');
                    };
                    this.image.src = url;
                } else {
                    this.$refs.video.src = url;
                    const promise = this.$refs.video.play();
                    if (promise) {
                        promise.then(_ => {
                            this.videoError = false;
                        }).catch(error => {
                            console.log('video play error!!!!!', error);

                            this.videoError = true;
                            this.$emit('next');

                            setTimeout(() => {
                                // this.$emit('next');
                            }, 1000);
                        });
                    } else {
                        setTimeout(() => {
                            // this.$emit('next');
                        }, 1000);
                    }
                }
            },

            hide() {
                this.$parent.$el.append(this.$el);

                TweenMax.to(this.$refs.container, 0.4, {
                    opacity: 0, delay: 0.2, onComplete: () => {
                        this.isVisible = false;
                    }, ease: Sine.easeInOut
                })
            }
        },
        mounted() {
            const video = this.$refs.video;
            if (video) {
                video.muted = true;
                video.addEventListener('ended', () => {
                    clearInterval(this.inv);
                    this.$emit('next');
                    console.log('ended');
                });

                // video.addEventListener('timeupdate', () => {
                //     const p = video.currentTime * 100 / video.duration;
                //     this.$emit('progress', p);
                // });
                video.addEventListener('canplay', () => {
                    if (!this.videoError) {
                        this.showVideo();
                    }

                });
            }
        },
        beforeDestroy() {
            clearInterval(this.inv);
            const video = this.$refs.video;
            if (video) {
                video.pause();
            }
        }
    }
</script>

<style scoped>
    .media-container {
        position: relative;
        cursor: pointer;
    }

    .slide {
        width: 100%;
    }

    .slide-container {
        position: absolute;
        top: 0;
        left: 0;
    }
</style>